import { atom } from "recoil";
export const userHasReviewedState = atom({
  key: "userHasReviewedState",
  default: false,
});